import { createAsyncAtom } from '../../lib';
import { callApiWithFallbacks } from '../../utils';

const OBL_LEND_ALLOCATION_ENDPOINT_PATH = '/openblock/supply_incentives';
const OBL_LEND_ALLOCATION_FALLBACK_ENDPOINT =
  'https://kx58j6x5me.execute-api.us-east-1.amazonaws.com/starknet/fetchFile?file=prod-api/lending/lending_strk_grant.json';

const lendAllocationsAtom = createAsyncAtom(async () => {
  try {
    const response = await callApiWithFallbacks(OBL_LEND_ALLOCATION_ENDPOINT_PATH, [
      OBL_LEND_ALLOCATION_FALLBACK_ENDPOINT,
    ]);
    const allocations = response.data.Nostra;

    return allocations;
  } catch (error) {
    console.error(error);
    return {};
  }
});

export default lendAllocationsAtom;
